import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useApprovalSearchCondition } from '@/providers/ApprovalSearchConditionProvider';
import { FilterModal } from '@/features/w/[identifier]/approval/{components}/FilterModal';
import { SearchConditionTags } from '@/features/w/[identifier]/approval/{components}/SearchConditionTags';
import { ListElement } from '@/features/w/[identifier]/approval/{components}/ListElement';
import { KanbanElement } from '@/features/w/[identifier]/approval/{components}/KanbanElement';

export const ApprovalTasks = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('承認待ち'), []);
  useEffect(() => setBreadcrumbs([]), []);

  const {
    approvalDisplayType: displayType,
    setApprovalDisplayType: setDisplayType,
    approvalSearchCondition: searchCondition,
  } = useApprovalSearchCondition();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <button className="btn btn-icon-only btn-dark mx-2" data-bs-toggle="modal" data-bs-target="#modal-filter">
            <i className="fas fa-filter"></i>
          </button>
        </div>

        <SearchConditionTags />

        <FilterModal />

        {displayType == 'list' && <ListElement />}
        {/*{displayType == 'kanban' && <KanbanElement />}*/}
      </div>
    </WorkspaceLayout>
  );
};
